import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.UsersPage.OffboardUserPopupContent', {
    instructionForWorkflow: 'Please select replacement for {displayName} for approval workflows.',
    instructionForReplacement:
        'Please select replacement for {displayName} for open approval requests.{br}Already approved requests will not be affected. Their history will clearly say that they were approved by him (her).',
    offBoardPopupTitle: 'Offboarding of {displayName}',
    offBoardPopupStepTitle: '(Step {stepNumber} of 2)',
    delegatesWarningText: 'All substitutes for {displayName} will be removed',
    defaultApprover: 'Default approver',
    externalRequester: 'External requester',
    requester: 'Requester',
    reviewer: 'Reviewer',
    editor: 'Editor',
    dextExternalRequester: 'Dext external requester',
    emailExternalRequester: 'Email external requester',
    approver: 'Approver',
    successfulOffboarding: 'User was offboarded',
    payer: 'Payer',
    defaultReviewer: 'Default reviewer',
});
